export enum ENDPOINTS {
    GET_CURRENT_USER = `/api/v1/login/get-current-user`,
    GET_AGENT_DETAILS = `/api/v1/agent`,
    POST_VERIFY_PASSWORD = `/api/v1/login/verify-password`,
    GET_CHECK_MOBILE_NUMBER = `/api/v1/login/check-mobile-number`,
    POST_SEND_LOGIN_OTP = `/api/v1/login/send-otp`,
    POST_VERIFY_LOGIN_OTP = `/api/v1/login/verify-login-otp`,
    POST_UPDATE_USER_PASSWORD = `/api/v1/login/update-password`,
    POST_USER_LOGIN = `/api/v1/login/user-login`,
    GET_CART_DETAILS = `/api/v1/cart/get-cart-details`,
    SHARE_PREMIUM_SERVICE = `/api/v1/premium-services/share`,
    POST_SHARE_CONTENT_PREMIUM_SERVICE = `/api/v1/premium-services/generateBrochure`,
    CREATE_LEAD = `/api/v1/zendesk/tickets`,
    POST_CANCEL_UPLOAD_CHEQUE = `/api/v2/profiles/upload-cancelled-cheque`,
    POST_BANK_ACCOUNT_VERIFICATION = `/api/v2/profiles/bank-account-verification`,
    GET_BANK_ACCOUNT_STATUS = `/api/v2/profiles/check-bank-account-status`,
    UPLOAD_SIGNATURE_PIC = `/api/v2/profiles/upload-signature`,
    GET_VERIFY_PINCODE = `/api/v1/pincode/get-pincode-details`,
    GET_CHECK_IFSC = `/api/v1/ifsc/search-ifsc`,
    POST_CREATE_AOF_URL = `/api/v1/checkout/create-aof-url`,
    GET_CHECK_BSE_STATUS = `/api/v1/login/check-bse-status`,
    GET_PARTNER_DETAILS = `/api/v1/mintpro/scratch-card/partner-details`,
    GET_SEND_TRANSACTION_OTP = `/api/v1/checkout/send-transaction-otp`,
    POST_VERIFY_TRANSACTION_OTP = `/api/v1/checkout/verify-transaction-otp`,
    GET_KYC_DETAILS = `/api/v1/get-kyc-details`,
    GET_PROFILE_DETAILS = `/api/v2/profiles/{ucc}`,
    POST_SAVE_PROFILE_DETAILS = `/api/v2/profiles/{ucc}`,
    UPDATE_SAVE_PROFILE_DETAILS = '/api/v2/profiles/update-user-profile/{ucc}',
    GET_REDIRECT_KYC = '/api/v1/kyc/request-kyc',
    GET_PORTFOLIO_DETAILS = '/api/v1/portfolio/get-user-portfolio',
    CREATE_BSE_ORDER = '/api/v1/checkout/create-bse-order',
    PORTFOLIO_TRANSACTION = '/api/v1/portfolio/portfolio-transaction',
    SIGNZY_AUTO_POPULATE = '/api/v2/profiles/signzy-auto-populate',
    GET_LOGOUT = '/api/v1/login/logout',
    SUGGEST_MUTUAL_FUNDS = '/api/v1/mf/suggest-mutual-fund',
    GET_USER_PROFILE_INFO = '/api/v1/profile',
    POST_VERIFY_OTP = '/api/v2/profiles/verify-otp',
    POST_SEND_OTP = '/api/v2/profiles/send-otp',
    POST_CREATE_AOF = '/api/v2/profiles/create-aof-url',
    GET_AGENT_CERTIFICATES = '/api/v1/agentCertificates/{agentCode}',
    // GET_CUSTOMER_COUNT = '/api/v1/cart/get-customer-count-totalAUM',
    POST_MERGE_CARTS = '/api/v1/login/merge-carts',
    POST_PROFILE_UPDATION_OTP = '/api/v2/profiles/send-profile-otp',
    POST_PROFILE_UPDATION_VERIFY_OTP = '/api/v2/profiles/verify-profile-OTP',
    MY_CUSTOMERS = '/api/v1/cart/get-customer-details',


    //risk-profile
    GET_RISK_PROFILE = `/api/v1/risk-profile`,
    GET_RISK_PROFILE_QUESTIONS = `/api/v1/risk-profile/questions`,
    GET_RISK_PROFILE_ANSWER_OPTIONS = `/api/v1/risk-profile/answer-options`,
    GET_RISK_PROFILE_RESULT = `/api/v1/risk-profile/user-risk-profile`,
    GET_RISK_PROFILE_MAX_USER_ATTEMPT_ID = `/api/v1/risk-profile/user-attempt-id`,

    //payment-flow
    SHARE_ORDER_SUMMARY = `/api/v1/payment/share`,
    POST_SHARE_ORDER_SUMMARY_CONTENT = `/api/v1/payment/share-payment-link`,
    GET_CHALLAN = `/api/v1/checkout/get-cheque-payment-details/{groupId}`,
    GET_CHALLAN_MOBILE = `/api/v1/checkout/get-cheque-payment-details-mobile/{groupId}`,
    GET_ORDER_DETAILS = `/api/v1/checkout/get-order-details`,
    POST_REPORT_INVALID_ORDERS = `/api/v1/payment/report-invalid-orders`,
    POST_MAKE_BSE_PAYMENT = `/api/v1/payment/bse-payment`,
    POST_INVALID_EXPIRED_ORDERS = `/api/v1/payment/handle-invalid-expired-orders`,
    POST_DISCARD_ACTIVE_CART = `/api/v1/cart/discard-active-cart`,
    POST_DISCARD_ACTIVE_ORDERS = `/api/v1/cart/discard-orders`,
    GET_ORDER_LIST = '/api/v1/checkout/get-order-list',

    //stp-swp
    POST_STP_SWP_REGISTRATION = `/api/v1/stp-swp/register-stp-swp/{ucc}`,
    POST_STP_SWP_CANCELLATION = `/api/v1/stp-swp/cancel-transaction/{ucc}`,
    GET_PORTFOLIO = `/api/v1/portfolio/get-user-portfolio`,
    GET_ALL_STP_ORDERS = `/api/v1/stp-swp/get-all-stp-swp-orders/{ucc}`,
    GET_DESTINATION_FUNDS = `/api/v1/stp-swp/same-amc-schemes`,
    GET_ACTIVE_SWP_ORDERS = `/api/v1/stp-swp/active-swp-orders/{ucc}`,
    GET_ALL_STP_SWP_ORDERS = `/api/v1/stp-swp/get-all-stp-swp-orders/{ucc}`,
    POST_SEND_STP_SWP_OTP = `/api/v1/stp-swp/send-otp/{ucc}`,
    POST_VERIFY_STP_SWP_OTP = `/api/v1/stp-swp/verify-otp/{ucc}`,
    POST_SAVE_BSE_ORDER = `/api/v1/stp-swp/save-stp-swp-order-to-bse/{ucc}`,
    GET_STP_VALIDATION_DETAILS = `/api/v1/stp-swp/stp-validation-details`,
    GET_STP_ALLOWED_DATES = '/api/v1/stp-swp/stp-allowed-dates',
    GET_CANCELLED_STP_ORDERS = '/api/v1/stp-swp/auto-cancelled-stp-orders/{ucc}',
    //Get mfpd by schemeId
    GET_MUTUAL_FUND_DETAIL = '/api/v1/mf/get-mutual-fund-detail',

    //mandates
    GET_USER_MANDATES_LIST = '/api/v1/mandate-details/user-mandates',
    GET_ACTIVATE_MANDATE_CONFIG = '/api/v1/mandate-details/activate-mandate-config',
    GET_REGISTERED_MANDATE = '/api/v1/mandate-details/get-registered-mandate',
    POST_ACTIVATE_MANDATE = '/api/v1/mandate-details/activate-mandate',
    POST_DOWNLOAD_PHYSICAL_MANDATE_FORM = '/api/v1/mandate-details/download-mandate',
    POST_SHARE_MANDATES_LINK = '/api/v1/mandate-details/share-mandate-setup-link',
    POST_UPLOAD__MANDATE = '/api/v1/mandate-details/upload-mandate',
    GET_SCRATCH_CARD = '/api/v1/mintpro/scratch-card',
    POST_SEND__SURVEY = '/api/v1/survey/send',

    //portfolio
    POST_REDEEM_REQUEST = '/api/v1/portfolio/redeem-request',
    POST_SHARE_PORTFOLIO = '/api/v1/cart/get-customer-details/sharePortfolio',

    //NFO LIST DETAILS API
    GET_NFO_FUNDS = '/api/v1/mf/NFO-details',
    POST_NFO_SHARE = '/api/v1/mf/share-NFO',

    //SIP-CALCULATOR
    SHARE_CALCULATOR_VIA_WHATSAPP = '/api/v1/cart/get-customer-details/share-investment-calculator-image',
    POST_SAVE_INTERESTED_CUSTOMER_DETAILS = '/api/v1/login/save-user',
    GET_AGENT_PROFILE_PICTURE = '/api/v1/mintpro/scratch-card/dp-profile-picture',

    //GET TOP RATED FUNDS
    GET_TOP_MUTUAL_FUNDS = '/api/v1/mf/get-top-mutual-funds',

    //HOME
    GET_REPORTS_URL = '/api/v1/get-reports-url',
    GET_DIWALI_PDF = '/api/v1/templates',
    GET_ACTIVE__CONTENT_DETAILS_FOR_DP = '/api/v2/profiles/activeContentDetails',
    GET_THUMBNAIL_IMAGE = '/api/v1/file/content-files',
    POST_DP_SUBSCRIPTION = '/api/v2/profiles/subscription',
    POST_HOMEPAGE_LEAD = '/api/v1/login/home-page-lead',
    GET_CALCULATOR_LEADS_COUNT = '/api/v1/leads/calculator-leads',

    //SEARCH
    GET_SEARCH_MUTUAL_FUNDS_BY_TEXT = '/api/v1/mf/search-mutual-funds-by-text',
    GET_MOST_SEARCHED_MUTUAL_FUNDS = '/api/v1/mf/get-most-viewed-mutual-funds',
    GET_SUGGEST_MUTUAL_FUNDS = '/api/v1/mf/suggest-mutual-fund',

    //MINTPACKS
    //GET_ALL_MINTPACK = '/api/v1/mp/get-all-mintpack',
    POST_SHARE_MINTPACK_LINK = '/api/v1/mp/share',


    POST_SAVE_INVESTMENT_DETAILS = '/api/v1/cart/save-investment-details',

    //KNOW-MORE
    GET_PREVIEW_NISM_CERTIFICATE = '/api/v1/agentCertificates/preview-nism-certificate',
    POST_UPLOAD_ARN_CERTIFICATE_PIC = '/api/v1/agentCertificates/upload-arn-certificate-pic',
    POST_UPLOAD_NISM_CERTIFICATE_PIC = '/api/v1/agentCertificates/upload-nism-certificate-pic',
    GET_PREVIEW_ARN_CERTIFICATE = '/api/v1/agentCertificates/preview-arn-certificate',

    GET_ALLOWED_MINT_AGENT= '/api/v0/customers/agent-transaction-allow'
}

export const API_BASE_URL = process.env.REACT_APP_API_URL;